import React from "react";

/**
 * Source trace previously displayed a sealed-trace message. The OS is now
 * allowed to quote freely, so no footer note is rendered.
 */
export default function SourceTrace() {
    return null;
}
